// import { createTheme } from '@mui/material/styles';

// // Custom theme configuration based on Materio Admin Template
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#8C57FF", // Primary blue color (from Materio)
//       light: "#A379FF",
//       dark: "#7E4EE6",
//     },
//     secondary: {
//       main: "#8A8D93", // Background color for the app, light gray
//       light: "#A1A4A9",
//       dark: "#7C7F84", // Darker variant for background
//     },
//     background: {
//       default: "#f4f5fa", // Light background color
//       paper: "#ffffff", // Paper color for elements like cards
//     },
//     text: {
//       primary: "#212529", // Dark text
//       secondary: "#6c757d", // Lighter text
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', // Font family
//     h1: {
//       fontSize: "2.5rem",
//       fontWeight: 600,
//       color: "#212529",
//     },
//     h2: {
//       fontSize: "2rem",
//       fontWeight: 500,
//       color: "#212529",
//     },
//     body1: {
//       fontSize: "1rem",
//       color: "#6c757d",
//     },
//     body2: {
//       fontSize: "0.875rem",
//       color: "#6c757d",
//     },
//     caption: {
//       fontSize: "0.75rem",
//       color: "#6c757d",
//     },
//   },
//   spacing: 8, // Define a global spacing multiplier (8px)
//   shape: {
//     borderRadius: 8, // Rounded corners for all elements
//   },
//   components: {
//     // MuiButton customizations
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           textTransform: "none",
//           borderRadius: "6px", // Button border radius
//           padding: "0.5rem 1.125rem", // Custom padding for button
//           minWidth: "64px", // Ensure consistent button width
//         },
//       },
//     },
//     // MuiTextField customizations
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           marginBottom: "16px", // Space between form elements
//           "& .MuiOutlinedInput-root": {
//             borderRadius: "8px", // Rounded textfield border
//           },
//           "& .MuiInputLabel-root": {
//             fontSize: "1rem", // Label font size
//           },
//           "& .MuiOutlinedInput-input": {
//             padding: "16px 14px", // Padding inside the text field
//           },
//         },
//       },
//     },
//     // MuiInputLabel customizations
//     MuiInputLabel: {
//       styleOverrides: {
//         root: {
//           color: "#6c757d", // Light text color for labels
//           "&.Mui-focused": {
//             color: "#5e72e4", // Change label color when focused
//           },
//         },
//       },
//     },
//     // MuiOutlinedInput customizations
//     MuiOutlinedInput: {
//       styleOverrides: {
//         root: {
//           "& fieldset": {
//             borderColor: "#ced4da", // Light border color for text fields
//           },
//           "&.Mui-focused fieldset": {
//             borderColor: "#5e72e4", // Focused fieldset border color
//           },
//         },
//       },
//     },
//     // MuiCard customizations
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Light shadow for cards
//           borderRadius: "12px", // Card border radius
//           padding: "20px", // Padding inside cards
//           backgroundColor: "#fff",
//         },
//       },
//     },
//     // MuiAppBar customizations
//     MuiAppBar: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#a379ff",
//           boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Slight shadow
//         },
//       },
//     },
//     // MuiDrawer customizations
//     MuiDrawer: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#ffffff", // Drawer background color
//           borderRight: "1px solid #e0e0e0", // Drawer border color
//         },
//       },
//     },
//     // MuiMenu customizations (used in the header menu)
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           borderRadius: "8px", // Rounded menu edges
//           boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", // Shadow for menus
//         },
//       },
//     },
//     MuiList: {
//       styleOverrides: {
//         root: {
//           padding: "10px",
//         },
//       },
//     },
//     MuiListItemButton: {
//       styleOverrides: {
//         root: {
//           "&:hover": {
//             backgroundColor: "#00000014",
//             borderRadius: "4px",
//           },
//           "&.Mui-selected": {
//             backgroundColor: "#8c57ff61",
//             // color: '#8C57FF',
//             fontWeight: "bold",
//             borderRadius: "4px",
//             "& .MuiTypography-root": {
//               color: "#8C57FF",
//               fontWeight: "700",
//             },
//           },
//         },
//       },
//     },
//     MuiBox: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#f0f0f0", // Set the default background color for Box
//           // You can add other styles as needed
//           padding: "16px", // Example: Set padding for all Box components
//         },
//       },
//     },
//     MuiSwitch: {
//       styleOverrides: {
//         root: {
//           width: 38,
//           height: 22,
//           padding: 0,
//           margin: 8,
//           '& .MuiSwitch-switchBase': {
//             padding: 1,
//             '&.Mui-checked': {
//               transform: 'translateX(16px)',
//               color: '#fff',
//               '& + .MuiSwitch-track': {
//                 opacity: 1,
//               },
//             },
//             '&.Mui-checked + .MuiSwitch-track': {
//             },
//           },
//           '& .MuiSwitch-track': {
//             borderRadius: 26 / 2,
//             backgroundColor: '#ccc',
//             opacity: 1,
//             transition: 'background-color 0.3s',
//           },
//         },
//       },
//     },
//     MuiTableHead: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#f6f7fb", // Background color
//           color: "#2e263de6", // Text color
//         },
//       },
//     },
//     MuiDialog:{
//       styleOverrides:{
//         root:{
//           backgroundColor: '#f4f5fa'
//         }
//       }
//     },
//     MuiDialogTitle: {
//       styleOverrides: {
//         root: {
//           '& .MuiTypography-root': {
//             fontSize: '1.5rem', // Set your desired font size here
//             fontWeight: 'bold', // You can also modify other typography properties here
//           },
//         },
//       },
//     },
//     MuiTab: {
//       styleOverrides: {
//         root: {
//            textTransform:'Capitalize',
//           '&.Mui-selected': {
//             color: '#a379ff',
//             fontWeight:'600',
//             textTransform:'Capitalize'
//           },
//         },
//         indicator: {
//           backgroundColor: '#a379ff',
//         },
//       },
//     },
//   },
// });

// export default theme;
import { createTheme } from "@mui/material/styles";

const getTheme = (themeOptions) => {
  return createTheme({
    palette: {
      mode: themeOptions.mode || "light", // light or dark mode
      primary: {
        main: themeOptions.primary || "#1976d2",
      },
      secondary: {
        main: themeOptions.secondary || "#ff4081",
      },
    },
    typography: {
      fontFamily: themeOptions.fontFamily || "Roboto, Arial",
    },
  });
};

export default getTheme;